<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="relative bg-white rounded-lg w-full max-w-xl p-2 mx-2 overflow-y-auto max-h-[80vh] mb-20 mt-5">

        <!-- <div class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50 overflow-y-auto">
  <div class="relative bg-white rounded-lg w-full max-w-xl p-4 mx-2 mt-10 mb-10"> -->
            <!-- Modal Header -->
            <div class="flex items-center justify-between p-2 px-4 border-b border-gray-50">
                <!-- Title -->
                <h2 class="text-lg font-semibold text-gray-800">{{ title }}</h2>
                <!-- Close Button -->
                <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
                    <AppIcon icon="mdi:close" class="h-5 w-5" />
                </button>
            </div>
            <!-- Modal Content -->
            <div class="p-4">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        title: {
            type: String,
            required: false,
            default: "", // Default title jika tidak diberikan
        },
    },
};
</script>

<style scoped>
/* Custom modal styles */
</style>
